import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fds-loading-table',
  templateUrl: './loading-table.component.html',
  styleUrls: ['./loading-table.component.scss']
})
export class LoadingTableComponent implements OnInit {

  @Input() columns:number = 6;
  @Input() rows: number = 10;
  @Input() line:number = 1;
  @Input() colHeight:string = '33px';

  lstColumns : any[] = [];
  lstRows : any[] = [];

  loadingTheme:any= {
		'height.px': 10,
		'border-radius': 0,
		'margin-bottom': 0,

		'background-color': '#d8d8d8'
  };

  constructor() { }

  ngOnInit() { 
    for (let i = 0; i < this.columns; i++) {
      this.lstColumns.push(i);
    }
    for (let i = 0; i < this.rows; i++) {
      this.lstRows.push(i);
    }
  }

}
